import TypeOfProduct from './typeOfProduct';

class Product {
  constructor(data) {
    if (!data) return undefined;
    this.code = data.code;
    this.name = data.name;
    this.typeOfProduct = new TypeOfProduct(data.typeOfProduct);
    this.collectivityDiscountAmount = data.collectivityDiscountAmount;
    this.nettoPremium = data.nettoPremium;
  }
}

export { Product as default };
